<template>
  <div>
    <el-collapse v-model="activeNames">
     <MyCollapse  title="家庭情况" name="1" iconPath="/static/de-family.png">
        <el-form :inline="true">
          <el-row type="flex" align="middle" style="margin-top: -10px;">
            <el-col :md="6">
              <el-form-item label="低保家庭">
                <el-radio-group v-model="info.isSubsistence">
                  <el-radio disabled :label="1">是</el-radio>
                  <el-radio disabled :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :md="6" v-if="info.isSubsistence == 1">
              <el-form-item label="低保月收入(元)">
                <el-input size="small" type="text" disabled :value="info.subsistenceAmount || '-'">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12" v-if="info.isSubsistence == 1">
              <el-form-item label="低保家庭证明">
                <FileUpload v-model="files.dbzmFIle" :disabled="true"></FileUpload>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="6">
              <el-form-item label="医保类型">
                <el-input size="small" type="text" disabled :value="info.medicalInsureTypeText || '-'"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :md="6">
              <el-form-item label="是否有重疾险/医疗险">
                <el-radio-group v-model="info.isBusinessInsure">
                  <el-radio disabled :label="1">是</el-radio>
                  <el-radio disabled :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-table v-if="info.isBusinessInsure == 1" :data="insureList">
            <el-table-column prop="insureCompany" label="保险公司">
              <template slot-scope="scope">{{scope.row.insureCompany || '-'}}</template>
            </el-table-column>
            <el-table-column prop="insureType" label="险种">
              <template slot-scope="scope">{{scope.row.insureType || '-'}}</template>
            </el-table-column>
            <el-table-column prop="insureAmount" label="保额(元)">
              <template slot-scope="scope">{{scope.row.insureAmount == 0 ? 0 : (scope.row.insureAmount || '-')}}</template>
            </el-table-column>
          </el-table>
          <el-form :inline="true">
            <el-row style="margin-bottom: -14px;">
              <el-form-item label="筹款形式">
                <el-checkbox-group v-model="info.otherFundraiseArr" style="margin-top: 6px;">
                  <el-checkbox label="0" disabled>无</el-checkbox>
                  <el-checkbox label="1" disabled>网络筹款</el-checkbox>
                  <el-checkbox label="2" disabled>其他基金会</el-checkbox>
                  <el-checkbox label="3" disabled>其他形式</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </el-row>
            <el-row v-if="info.otherFundraise && info.otherFundraise.indexOf('1') >= 0">
              <el-col :md="12">
                <el-form-item label="筹款平台">
                  <el-input size="small" type="text" disabled :value="info.fundraisePlatform || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="筹款金额(元)">
                  <el-input size="small" type="text" disabled :value="info.fundraiseAmount == 0 ? 0 : (info.fundraiseAmount || '-')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="info.otherFundraise && info.otherFundraise.indexOf('2') >= 0">
              <el-col :md="12">
                <el-form-item label="基金会名称">
                  <el-input size="small" type="text" disabled :value="info.foundationName || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="资助金额(元)">
                  <el-input size="small" type="text" disabled :value="info.helpAmount == 0 ? 0 : (info.helpAmount || '-')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="info.otherFundraise && info.otherFundraise.indexOf('3') >= 0">
              <el-col :md="12">
                <el-form-item label="其他">
                  <el-input size="small" type="textarea" disabled :value="info.otherFundraiseDesc || '-'" :autosize="{ minRows: 1, maxRows: 3 }"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="筹款金额(元)">
                  <el-input size="small" type="text" disabled :value="info.otherFundraiseAmount == 0 ? 0 : (info.otherFundraiseAmount || '-')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-form>
      </MyCollapse>
      <MyCollapse  title="家庭成员" iconPath="/static/de-home.png" name="2" >
        <div class="screen" style="margin-bottom: 20px; margin-top: -10px;">
          <el-form :inline="true">
            <el-row type="flex" align="middle">
              <el-col :md="6">
                <el-form-item label="是否仅有一个监护人">
                  <el-radio-group v-model="info.onlyOneGuardian">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="6" v-if="info.onlyOneGuardian == 1">
                <el-form-item label="原因">
                  <el-input size="small" type="text" disabled :value="info.onlyOneCauseText || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-if="info.onlyOneGuardian == 1 && info.onlyOneCause == 2">
                <el-form-item label="监护人离婚证/法院判决书">
                  <FileUpload v-model="files.onlyOneFile" :disabled="true"></FileUpload>
                </el-form-item>
              </el-col>
              <el-col :md="12" v-if="info.onlyOneGuardian == 1 && info.onlyOneCause == 3">
                <el-form-item label="死亡证明/户口注销页">
                  <FileUpload v-model="files.onlyOneFile" :disabled="true"></FileUpload>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="info.onlyOneGuardian == 1 && info.onlyOneCause == 4">
              <el-col :md="12">
                <el-form-item label="其他原因说明">
                  <el-input size="small" type="textarea" disabled :value="info.otherCause || '-'" :autosize="{ minRows: 1, maxRows: 3 }"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="监护人信息" :level="2"></ChapterHead> -->
            <el-table :data="parentsList" style="margin-bottom: 12px;">
              <el-table-column prop="guardianName" label="监护人姓名" width="110">
                <template slot-scope="scope">
                  <TableCellWordBreak :content="scope.row.guardianName">{{scope.row.guardianName || '-'}}</TableCellWordBreak>
                </template>
              </el-table-column>
              <el-table-column prop="guardianRelationText" label="与患儿关系" width="110">
                <template slot-scope="scope">{{scope.row.guardianRelationText || '-'}}</template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" width="60">
                <template slot-scope="scope">{{scope.row.age || '-'}}</template>
              </el-table-column>
              <el-table-column prop="guardianRelation" label="证件类型" width="100">
                <template slot-scope="scope">{{scope.row.documentRelationText || '-'}}</template>
              </el-table-column>
              <el-table-column prop="idNumber" width="180" label="证件号码">
                <template slot-scope="scope">{{scope.row.idNumber || '-'}}</template>
              </el-table-column>
              <el-table-column prop="wechat" label="微信号">
                <template slot-scope="scope">{{scope.row.wechat || '-'}}</template>
              </el-table-column>
              <el-table-column prop="phone" width="120" label="联系电话">
                <template slot-scope="scope">{{scope.row.phone || '-'}}</template>
              </el-table-column>
              <el-table-column prop="educationText" label="文化程度" width="80">
                <template slot-scope="scope">{{scope.row.educationText || '-'}}</template>
              </el-table-column>
              <el-table-column prop="isDisability" label="是否残疾" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.isDisability == 1">是</span>
                  <span v-else-if="scope.row.isDisability == 0">否</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="disabilityAttach" label="残疾证">
                <template slot-scope="scope">
                  <span v-if="scope.row.disabilityAttach && scope.row.disabilityAttach.length > 0">
                    <img
                      v-for="(item, index) in scope.row.disabilityAttach" :key="item.fileUrl"
                      src="/static/pic.png"
                      style="width: 24px; height: 24px; cursor: pointer;"
                      @click="handlePreview(item.fileUrl, index)"/>
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="workSituationText" label="工作情况" width="110">
                <template slot-scope="scope">
                  <el-popover placement="right" width="800" trigger="click">
                    <el-descriptions v-if="scope.row.workSituation == 1" :column="3" title="工作信息" border>
                      <el-descriptions-item label="单位名称">{{ scope.row.unitName || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="职业">{{ scope.row.occupation || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="职务">{{ scope.row.duties || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="单位电话">{{ scope.row.unitTelephone || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="月收入（元）">
                        {{ scope.row.monthlyIncomeText == 0 ? 0 : (scope.row.monthlyIncomeText || "-") }}
                      </el-descriptions-item>
                      <el-descriptions-item label="工作年限">{{ scope.row.workingYears || '-' }}</el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions size="mini" v-if="scope.row.workSituation == 2" :column="3" title="工作信息" border>
                      <el-descriptions-item label="打工地点">
                        {{ scope.row.workingProvinceText ? scope.row.workingProvinceText + scope.row.workingCityText : '-' }}
                      </el-descriptions-item>
                      <el-descriptions-item label="工种">{{ scope.row.workTypeText || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="单位/工友电话">{{ scope.row.workersTelephone || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="每年打工时间（月）">{{ scope.row.workTimeOfYear || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="单位名称">{{ scope.row.unitName || '-' }}</el-descriptions-item>
                      <el-descriptions-item label="月收入（元）">{{ scope.row.averageIncome == 0 ? 0 : (scope.row.averageIncome || "-") }}
                      </el-descriptions-item>
                    </el-descriptions>
                    <el-descriptions size="mini" v-if="scope.row.workSituation != 2 && scope.row.workSituation != 1"
                                     :column="2" title="工作信息" border>
                      <el-descriptions-item label="月收入（元）">{{ scope.row.averageIncome == 0 ? 0 : (scope.row.averageIncome || "-") }}
                      </el-descriptions-item>
                      <el-descriptions-item label="其他情况描述">{{ scope.row.otherSituation || '-' }}</el-descriptions-item>
                    </el-descriptions>
                    <span class="link" slot="reference">{{ scope.row.workSituationText || '-' }}</span>
                  </el-popover>
                </template>
              </el-table-column>
            </el-table>
            <el-row>
              <el-col :span="6">
                <el-form-item label="是否有与患儿共同生活的其他家庭成员(患儿兄弟姐妹、患儿祖父母等)">
                  <el-radio-group v-model="info.hasFamilyMember">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="是否有共同生活家庭成员" :level="2">
              <el-radio-group style="margin-left: 20px" v-model="info.hasFamilyMember">
                <el-radio disabled :label="1">是</el-radio>
                <el-radio disabled :label="0">否</el-radio>
              </el-radio-group>
            </ChapterHead> -->
            <el-table v-if="info.hasFamilyMember == 1" :data="familyMemberList">
              <el-table-column prop="memberName" label="姓名" width="110">
                <template slot-scope="scope">
                  <TableCellWordBreak :content="scope.row.memberName">{{scope.row.memberName || '-'}}</TableCellWordBreak>
                </template>
              </el-table-column>
              <el-table-column prop="memberRelationText" label="与患儿关系" width="110">
                <template slot-scope="scope">{{scope.row.memberRelationText || '-'}}</template>
              </el-table-column>
              <el-table-column prop="age" label="年龄" width="60">
                <template slot-scope="scope">{{scope.row.age || '-'}}</template>
              </el-table-column>
              <el-table-column prop="educationText" label="文化程度" width="80">
                <template slot-scope="scope">{{scope.row.educationText || '-'}}</template>
              </el-table-column>
              <el-table-column label="是否在工作" width="90">
                <template slot-scope="scope">
                  <span v-if="scope.row.isWork == 1">是</span>
                  <span v-else-if="scope.row.isWork == 0">否</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="是否有退休金" width="110">
                <template slot-scope="scope">
                  <span v-if="scope.row.hasPension == 1">是</span>
                  <span v-else-if="scope.row.hasPension == 0">否</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="retireUnit" label="退休单位">
                <template slot-scope="scope">
                  {{ scope.row.retireUnit || "-" }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="退休时间">
                <template v-slot="scope">
                  <span v-if="scope.row.retireTime">{{parseTime(scope.row.retireTime, '{y}-{m}-{d}')}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="monthlyPension" label="退休金(元/月)" width="110">
                <template slot-scope="scope">
                  {{ scope.row.monthlyPension == 0 ? 0 : (scope.row.monthlyPension || "-") }}
                </template>
              </el-table-column>
              <el-table-column label="户口本页">
                <template slot-scope="scope">
                  <span v-if="scope.row.hkAttach">
                    <img
                      v-for="(item, index) in scope.row.hkAttach" :key="item.fileUrl"
                      src="/static/pic.png"
                      style="width: 24px; height: 24px; cursor: pointer;"
                      @click="handlePreview(item.fileUrl, index)"/>
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="家庭收入情况" iconPath="/static/de-home.png" name="2" >
        <div class="screen" style="margin-top: -10px;">
          <el-form :inline="true">
            <el-row>
              <el-col :md="6">
                <el-form-item label="家庭总年收入">
                  <el-input size="small" type="text" disabled :value="info.yearAmountTotal == 0 ? 0 : (info.yearAmountTotal || '-')">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="本次患儿生病前家庭积蓄">
                  <el-input size="small" type="text" disabled :value="info.familySavings == 0 ? 0 : (info.familySavings || '-')">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6" style="line-height: 42px;">
                （单位：元）
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="6">
                <el-form-item label="是否有农林牧渔">
                  <el-radio-group v-model="info.isAgriculture">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="18" v-if="info.isAgriculture==1">
                <el-form-item label="农林牧渔说明">
                  <el-input size="small" type="textarea" disabled :value="info.agricultureType || '-'" :autosize="{ minRows: 1, maxRows: 3 }"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :md="6">
                <el-form-item label="是否有其他收入">
                  <el-radio-group v-model="info.hasOtherIncome">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="18" v-if="info.hasOtherIncome == 1">
                <el-form-item label="其他收入说明">
                  <el-input size="small" type="textarea" disabled :value="info.otherIncomeDesc || '-'" :autosize="{ minRows: 1, maxRows: 3 }">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="家庭资产情况" iconPath="/static/de-money.png" name="3" >
        <div class="screen" style="margin-bottom: 20px; margin-top: -10px;">
          <el-form :inline="true">
            <el-row>
              <el-col>
                <el-form-item label="家庭住房">
                  <el-radio-group v-model="info.houseType">
                    <el-radio disabled label="1">无</el-radio>
                    <el-radio disabled label="2">自建房</el-radio>
                    <el-radio disabled label="3">买房</el-radio>
                    <el-radio disabled label="4">租房</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="自建房" v-if="info.houseType == 2" :level="2"></ChapterHead> -->
            <el-row v-if="info.houseType == 2">
              <el-col :md="6">
                <el-form-item label="建房时间">
                  <el-input size="small" type="text" disabled :value="info.houseBuildTime ? parseTime(info.houseBuildTime, '{y}-{m}-{d}') : '-'">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="建房花费(元)">
                  <el-input size="small" type="text" disabled :value="info.houseBuildCost == 0 ? 0 : (info.houseBuildCost || '-')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="建房间数">
                  <el-input size="small" type="text" disabled :value="info.houseBuildRoomCount == 0 ? 0 : (info.houseBuildRoomCount || '-')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="房屋所在地">
                  <el-input size="small" type="text" disabled :value="info.houseBuildProvinceText ? info.houseBuildProvinceText + ' / ' + info.houseBuildCityText + ' / ' + info.houseBuildCountyText : '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="房屋详细地址">
                  <el-input size="small" type="text" disabled :value="info.houseBuildStreet || '-'"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="买房" v-if="info.houseType == 3" :level="2"></ChapterHead> -->
            <el-row v-if="info.houseType == 3">
              <el-col :md="6">
                <el-form-item label="买房时间">
                  <el-input size="small" type="text" disabled :value="info.houseBuyTime ? parseTime(info.houseBuyTime, '{y}-{m}-{d}') : '-'">
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="房屋所在地">
                  <el-input size="small" type="text" disabled :value="info.houseBuyProvinceText ? info.houseBuyProvinceText + ' / ' + info.houseBuyCityText + ' / ' + info.houseBuyCountyText : '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="12">
                <el-form-item label="房屋详细地址">
                  <el-input size="small" type="text" disabled :value="info.houseBuyStreet || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="小区名称">
                  <el-input size="small" type="text" disabled :value="info.houseBuyCommunity || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="房屋面积">
                  <el-input size="small" type="text" disabled :value="info.houseBuyArea == 0 ? 0 : (info.houseBuyArea || '-')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="房产总价">
                  <el-input size="small" type="text" disabled :value="info.houseBuyPrice == 0 ? 0 : (info.houseBuyPrice || '-')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="是否贷款">
                  <el-radio-group v-model="info.houseBuyIsBorrow">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="info.houseType == 3">
              <el-col :md="6">
                <el-form-item label="首付">
                  <el-input size="small" type="text" disabled :value="info.houseBuyIsBorrow == 1 ? (info.houseBuyFirstPay == 0 ? 0 : (info.houseBuyFirstPay || '-')) : '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="贷款金额">
                  <el-input size="small" type="text" disabled :value="info.houseBuyIsBorrow == 1 ? (info.houseBuyBorrowAmount == 0 ? 0 : (info.houseBuyBorrowAmount || '-')) : '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="月供">
                  <el-input size="small" type="text" disabled :value="info.houseBuyIsBorrow == 1 ? (info.houseBuyMonthlyPay == 0 ? 0 : (info.houseBuyMonthlyPay || '-')) : '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="是否抵押或出售">
                  <el-radio-group v-model="info.houseBuyIsMortgage">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead v-if="info.houseType == 4" title="租房" :level="2"></ChapterHead> -->
            <el-row v-if="info.houseType == 4">
              <el-col :md="6">
                <el-form-item label="租房地点">
                  <el-input size="small" type="text" disabled :value="info.houseRentingProvinceText || '-'"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="租金（月）">
                  <el-input size="small" type="text" disabled :value="info.houseRentingRent == 0 ? 0 : (info.houseRentingRent || '-')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :md="6">
                <el-form-item label="面积">
                  <el-input size="small" type="text" disabled :value="info.houseRentingArea == 0 ? 0 : (info.houseRentingArea || '-')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-form :inline="true">
            <el-row>
              <el-col :md="6">
                <el-form-item label="是否有其他情况">
                  <el-radio-group v-model="info.hasOtherSituation">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :md="18" v-if="info.hasOtherSituation == 1">
                <el-form-item label="其他情况说明">
                  <el-input size="small" type="textarea" disabled :value="info.otherSituation || '-'" :autosize="{ minRows: 1, maxRows: 3 }"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="6">
                <el-form-item label="是否有车辆">
                  <el-radio-group v-model="info.hasCar">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="是否有车辆" :level="2">
              <el-radio-group style="margin-left: 20px" v-model="info.hasCar">
                <el-radio disabled :label="1">是</el-radio>
                <el-radio disabled :label="0">否</el-radio>
              </el-radio-group>
            </ChapterHead> -->

            <el-table :data="info.carList" v-if="info.hasCar == 1">
              <el-table-column prop="carBrand" label="汽车品牌及型号">
                <template slot-scope="scope">{{scope.row.carBrand || '-'}}</template>
              </el-table-column>
              <el-table-column prop="carBuyTime" label="购车时间">
                <template v-slot="scope">
                  {{ scope.row.carBuyTime ? parseTime(scope.row.carBuyTime, '{y}-{m}-{d}') : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="carBuyAmount" label="购买金额(元)">
                <template slot-scope="scope">{{scope.row.carBuyAmount == 0 ? 0 : (scope.row.carBuyAmount || '-')}}</template>
              </el-table-column>
              <el-table-column prop="carIsBorrow" label="是否贷款">
                <template slot-scope="scope">
                  <span v-if="scope.row.carIsBorrow == 1">是</span>
                  <span v-else-if="scope.row.carIsBorrow == 0">否</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column prop="carBorrowAmount" label="贷款金额(元)">
                <template slot-scope="scope">
                  {{scope.row.carIsBorrow == 0 ? '-' : (scope.row.carBorrowAmount == 0 ? 0 : (scope.row.carBorrowAmount || '-'))}}
                </template>
              </el-table-column>
              <el-table-column prop="carMonthlyPay" label="月供金额(元)">
                <template slot-scope="scope">
                  {{scope.row.carIsBorrow == 0 ? '-' : (scope.row.carMonthlyPay == 0 ? 0 : (scope.row.carMonthlyPay || '-'))}}
                </template>
              </el-table-column>
              <el-table-column prop="carIsMortgage" label="是否抵押出售">
                <template slot-scope="scope">
                  <span v-if="scope.row.carIsMortgage == 1">是</span>
                  <span v-else-if="scope.row.carIsMortgage == 0">否</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="家庭债务情况" iconPath="/static/de-money.png" name="3" >
        <div class="screen" style="margin-bottom: 20px; margin-top: -10px;">
          <el-form :inline="true">
            <el-row>
              <el-col :span="6">
                <el-form-item label="家中是否有债务">
                  <el-radio-group v-model="info.hasDebt">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="家中是否有债务" :level="2">
              <el-radio-group style="margin-left: 20px" v-model="info.hasDebt">
                <el-radio disabled :label="1">是</el-radio>
                <el-radio disabled :label="0">否</el-radio>
              </el-radio-group>
            </ChapterHead> -->
            <el-table :data="debtData" v-if="info.hasDebt == 1">
              <el-table-column prop="debtTypeText" label="贷款/借债来源">
                <template slot-scope="scope">{{scope.row.debtTypeText || '-'}}</template>
              </el-table-column>
              <el-table-column prop="borrowReason" label="贷款/借贷用途">
                <template slot-scope="scope">{{scope.row.borrowReason || '-'}}</template>
              </el-table-column>
              <el-table-column label="贷款/借贷时间">
                <template v-slot="scope">
                  {{ scope.row.borrowTime ? parseTime(scope.row.borrowTime, '{y}-{m}-{d}') : '-' }}
                </template>
              </el-table-column>
              <el-table-column prop="borrowAmount" label="贷款/借贷金额(元)">
                <template slot-scope="scope">{{scope.row.borrowAmount == 0 ? 0 : (scope.row.borrowAmount || '-')}}</template>
              </el-table-column>
              <el-table-column prop="repayAmount" label="已偿还金额(元)">
                <template slot-scope="scope">{{scope.row.repayAmount == 0 ? 0 : (scope.row.repayAmount || '-')}}</template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="证明人说明" iconPath="/static/de-zmr.png" name="4" >
        <div class="screen" style="margin-bottom: 20px;">
          <el-form :inline="true">
            <!-- <ChapterHead title="证明人" :level="2"></ChapterHead> -->
            <el-table :data="certifierlist">
              <el-table-column prop="certifierName" label="证明人姓名" width="160">
                <template slot-scope="scope">{{scope.row.certifierName || '-'}}</template>
              </el-table-column>
              <el-table-column prop="certifierPhone" label="证明人电话" width="140">
                <template slot-scope="scope">{{scope.row.certifierPhone || '-'}}</template>
              </el-table-column>
              <el-table-column prop="certifierRelation" label="证明人与患儿监护人关系" width="220">
                <template slot-scope="scope">{{scope.row.certifierRelation || '-'}}</template>
              </el-table-column>
              <el-table-column prop="certifierAddr" label="证明人生活详细地址">
                <template slot-scope="scope">{{scope.row.certifierAddr || '-'}}</template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="近5年内重大事故说明" iconPath="/static/de-zmr.png" name="4" >
        <div class="screen" style="margin-bottom: 20px;">
          <el-form :inline="true">
            <el-row>
              <el-col :span="6">
                <el-form-item label="近5年内是否有重大事故">
                  <el-radio-group v-model="info.hasMajorAccident">
                    <el-radio disabled :label="1">是</el-radio>
                    <el-radio disabled :label="0">否</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- <ChapterHead title="近5年内是否有重大事故" :level="2">
              <el-radio-group v-model="info.hasMajorAccident">
                <el-radio disabled :label="1">有</el-radio>
                <el-radio disabled :label="0">无</el-radio>
              </el-radio-group>
            </ChapterHead> -->
            <el-row v-if="info.hasMajorAccident == 1">
              <el-col :md="12">
                <el-form-item label="近5年内重大事故说明">
                  <el-input size="small" type="textarea" disabled :value="info.majorAccidentDesc || '-'" :autosize="{ minRows: 3, maxRows: 10 }"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="补充资料（非必填项）"  iconPath="/static/de-att.png" name="5" >
        <div class="screen" style="margin-bottom: 20px;">
          <el-form>
            <!-- <ChapterHead title="视频资料" :level="2"></ChapterHead> -->
            <el-form-item>
              <FileUpload v-model="files.familyVideoFile" :disabled="true"></FileUpload>
            </el-form-item>
          </el-form>
        </div>
      </MyCollapse>
      <MyCollapse  title="相关证明附件" iconPath="/static/de-att.png" name="6" >

<!--        <ChapterHead title="相关证明附件" :level="1"></ChapterHead>-->
        <div class="screen" style="margin-bottom: 20px; margin-top: -16px;">
          <el-form>
            <ChapterHead title="申请须知" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.requestNoticeList" :disabled="true"></FileUpload>
            </el-form-item>
            <ChapterHead title="知情同意书" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.consentList" :disabled="true"></FileUpload>
            </el-form-item>
            <div v-if="helpData.isAlipay == 1 || helpData.isWelfareBaby == 1">
              <ChapterHead title="支付宝账号信息授权书" :level="2"></ChapterHead>
              <el-form-item>
                <FileUpload v-model="files.aliConsentList" :disabled="true"></FileUpload>
              </el-form-item>
            </div>
            <ChapterHead title="家庭情况证明" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.poorEvidenceList" :disabled="true"></FileUpload>
            </el-form-item>
            <!-- <ChapterHead title="患儿生活照" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.lifePhotoList" :disabled="true"></FileUpload>
            </el-form-item> -->
            <!-- <ChapterHead title="患儿在院照片" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.inHospitalPhotoList" :disabled="true"></FileUpload>
            </el-form-item> -->
            <ChapterHead title="患儿家人全家福" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.familyPhotoList" :disabled="true"></FileUpload>
            </el-form-item>
            <ChapterHead title="患儿生活照" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.facePhotoList" :disabled="true"></FileUpload>
            </el-form-item>
            <!-- <ChapterHead title="家庭困难自述" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.poorNarrateList" :disabled="true"></FileUpload>
            </el-form-item> -->
            <ChapterHead title="患儿户口本页/出生证明" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.registerPageList" :disabled="true"></FileUpload>
            </el-form-item>
            <!-- <ChapterHead title="其他资料" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.otherMaterialList" :disabled="true"></FileUpload>
            </el-form-item> -->
            <ChapterHead title="监护人户口本" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.gruandRegisterPageList" :disabled="true"></FileUpload>
            </el-form-item>
            <ChapterHead title="监护人身份证" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.idCardList" :disabled="true"></FileUpload>
            </el-form-item>
            <ChapterHead title="患儿身份证" :level="2" style="margin-top: -24px;"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.idCardPhotoList" :disabled="true"></FileUpload>
            </el-form-item>
            <!-- <ChapterHead title="患儿出生证明" :level="2"></ChapterHead>
            <el-form-item>
              <FileUpload v-model="files.birthCertificateList" :disabled="true"></FileUpload>
            </el-form-item> -->
          </el-form>
        </div>
      </MyCollapse>
    </el-collapse>
    <ImageViewer v-if="showViewer" :on-close="() => showViewer = false" :url-list="imageList" :z-index="20000"></ImageViewer>
  </div>
</template>

<script>
  import {
    downFileApi,
    getFileListByIds,
    getcertifierDataByHelpId,
    getDataByHelpId,
    getEvidenceAttachInfo,
    getFamilyAttachInfo,
    getFamilyDataByHelpId,
    getGuardianAttachInfo,
    getInsureDataByHelpId,
    getJzshDataListByCondNoPaging,
    getParentsDataByHelpId,
    getRequestAttachInfo,
    getOtherIncome,
    getFamilyMemberByHelpId,
    getMemberAttachInfo
  } from "@/util/api";
  import ImageViewer from 'element-ui/packages/image/src/image-viewer'
  import TableCellWordBreak from "@/components/business/TableCellWordBreak"
  import ChapterHead from "@/components/business/ChapterHead";
  import FileUpload from "@/components/business/FileUpload";
  import MyCollapse from "@/components/business/MyCollapse";
  export default {
    components: {
      ImageViewer,
      ChapterHead,
      FileUpload,
      MyCollapse,
      TableCellWordBreak
    },
    props: {
      helpId: String,
      helpData: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data() {
      return {
        showViewer: false,
        imageList: [],
        initialIndex: 0,
        info: {},
        insureList: [],
        parentsList: [],
        familyMemberList: [],
        activeNames:['1','2','3','4','5','6'],
        otherIncomeList: [],
        certifierlist: [],
        debtData: [],
        infoList: [],
        files: {
          dbzmFIle: [],
          fpzmFile: [],
          onlyOneFile: [],
          familyVideoFile:[],
          zdzmImage: [],
          consentList: [],
          aliConsentList: [],
          poorEvidenceList: [],
          lifePhotoList: [],
          inHospitalPhotoList: [],
          familyPhotoList: [],
          poorNarrateList: [],
          registerPageList: [],
          gruandRegisterPageList: [],
          otherMaterialList: [],
          idCardList: [],
          facePhotoList: [],
          idCardPhotoList: [],
          birthCertificateList: []
        }
      }
    },
    mounted() {
      this.loadData();
    },
    methods: {
      loadData() {
        this.getFamilyData();
        this.getParentsData();
        this.getInsureDataByHelpId();
        this.getFamilyAttach();
        this.getRequestAttachInfo();
        this.getRequestAttach();
        this.getDataByHelpId();
        this.getcertifier();
        this.getOtherIncome();
        this.getFamilyMember();
      },
      handleAmount(flag,resultObj,sourceObj){
				let arr = ['subsistenceAmount', 'fundraiseAmount', 'carBuyAmount', 'annualIncome',
						'familySavings', 'helpAmount', 'houseBuildCost', 'houseBuildRoomCount',
						'majorAccidentAmount', 'majorDiseaseAmount', 'majorExpendAmount',
						'yearAmountTotal', 'houseBuyArea', 'houseBuyPrice', 'houseRentingRent',
						'houseRentingArea', 'houseBuyFirstPay', 'houseBuyBorrowAmount',
						'houseBuyMonthlyPay', 'carBorrowAmount', 'carMonthlyPay', 'otherFundraiseAmount'
					]
				if(flag =="query"){
					arr.map(file => {
						resultObj[file] = (sourceObj[file] !== null && sourceObj[
							file] !== undefined) ? this.Utils.dealThousands(sourceObj[file] + '', 1) : ''
						resultObj[file+"Cn"] = (sourceObj[file] !== null && sourceObj[
							file] !== undefined) ? this.Utils.digitUppercase(sourceObj[file]) : ''
					})
				}else if(flag =="save"){
					arr.map(file => {
						resultObj[file] = resultObj[file].replace(/,|\s/g, '')
					})
				}
 			},      
      getFamilyData() {
        getFamilyDataByHelpId({
          helpId: this.helpData.helpId
        }).then(res => {
          if (res.msgCode == 200) {
            console.log(res.responseData)

            this.info = res.responseData;
            if (this.info.otherFundraise) this.info.otherFundraiseArr = this.info.otherFundraise.split(',')
            this.info.houseBuildProvinceText = this.info.houseBuildProvinceText;
            this.info.houseBuyProvinceText = this.info.houseBuyProvinceText;
            this.info.houseRentingProvinceText = this.info.houseRentingProvinceText ? this.info.houseRentingProvinceText + this.info
              .houseRentingCityText + this.info.houseRentingCountyText + this.info.houseRentingStreet : '-';
            
            this.handleAmount("query", this.info, res.responseData)
            
            let carList = [{
              'carBrand': this.info.carBrand,
              'carModel': this.info.carModel,
              'carBuyTime': this.info.carBuyTime,
              'carBuyAmount': this.info.carBuyAmount,
              'carIsBorrow': this.info.carIsBorrow,
              'carFirstPay': this.info.carFirstPay,
              'carBorrowAmount': this.info.carBorrowAmount,
              'carMonthlyPay': this.info.carMonthlyPay,
              'carIsMortgage': this.info.carIsMortgage,
            }]
            this.info.carList = carList
          }
        })
      },
      //获取监护人信息
      getParentsData() {
        let that = this
        this.files.gruandRegisterPageList = []
        this.files.idCardList = []
        getParentsDataByHelpId({
          helpId: this.helpData.helpId
        }).then(res => {
          this.parentsList = res.responseData
          if (this.parentsList.length > 0) {
            this.parentsList.forEach((item, index) => {
              //监护人户口本
              getGuardianAttachInfo({
                "subDataId": item.guardianId,
                "attachType": "21"
              }).then(resAttach => {
                if (resAttach.responseData.length > 0) {
                  that.files.gruandRegisterPageList = [];
                  let _list = that.Utils.getAttachId(resAttach.responseData)
                  that.files.gruandRegisterPageList = that.files.gruandRegisterPageList.concat(_list)
                }
              })
              //监护人身份证
              getGuardianAttachInfo({
                "subDataId": item.guardianId,
                "attachType": "22"
              }).then(resAttach => {
                if (resAttach.responseData.length > 0) {
                  that.files.idCardList = [];
                  let _list = that.Utils.getAttachId(resAttach.responseData)
                  that.files.idCardList = that.files.idCardList.concat(_list)
                }
              })
              //残疾证
              if (item.isDisability == 1) {
                getGuardianAttachInfo({
                  "subDataId": item.guardianId,
                  "attachType": "23"
                }).then(resAttach => {
                  if (resAttach.responseData.length > 0) {
                    let param = that.Utils.getAttachId(resAttach.responseData);
                    getFileListByIds(param).then(res1 => {
                      that.$set(that.parentsList[index], 'disabilityAttach', res1.responseData)
                    })
                  }
                })
              }
            })
            this.files.gruandRegisterPageList = this.Utils.getAttachId(this.files.gruandRegisterPageList)
            this.files.idCardList = this.Utils.getAttachId(this.files.idCardList)
          }
        })

      },
      handleQueryAmount(arr,params){
				if(params==null || params.length<=0){
					return
				}
				params.forEach((obj, index) => {
					arr.map(file => { 
						obj[file+"Cn"] = (obj[file] !== null && obj[
							file] !== undefined) ? this.Utils.digitUppercase(obj[file]) : ''
						obj[file] = (obj[file] !== null && obj[
							file] !== undefined) ? this.Utils.dealThousands(obj[file] + '', 1) : ''
					})
				})
 				console.log("params ==",params)
			},
			getInsureDataByHelpId() {
        getInsureDataByHelpId({
          helpId: this.helpData.helpId
        }).then(res => {
          this.insureList = res.responseData
          let arr = ['insureAmount']				
          this.handleQueryAmount(arr,this.insureList)
        });
      },
      getFamilyAttach() {
        getFamilyAttachInfo({
          helpId: this.helpData.helpId,
          attachType: '11'
        }).then(res => {
          if (res.responseData.length > 0) this.files.dbzmFIle = this.Utils.getAttachId(res.responseData)
        })
        getFamilyAttachInfo({
          helpId: this.helpData.helpId,
          attachType: '12'
        }).then(res => {
          if (res.responseData.length > 0) this.files.fpzmFile = this.Utils.getAttachId(res.responseData)
        })
        getFamilyAttachInfo({
          helpId: this.helpData.helpId,
          attachType: '13'
        }).then(res => {
          if (res.responseData.length > 0) this.files.onlyOneFile = this.Utils.getAttachId(res.responseData)
        })
        getFamilyAttachInfo({
          helpId: this.helpData.helpId,
          attachType: '14'
        }).then(res => {
          if (res.responseData.length > 0) this.files.familyVideoFile = this.Utils.getAttachId(res.responseData)
        })
      },
      getRequestAttachInfo() {
        getRequestAttachInfo({
          helpReqId: this.helpData.helpReqId,
          attachType: '21'
        }).then(res => {
          if (res.responseData.length > 0) this.files.zdzmImage = this.Utils.getAttachId(res.responseData)
        })
      },
      getRequestAttach() {
        //申请须知
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "14"
        }).then(res => {
          if (res.responseData.length > 0) this.files.requestNoticeList = this.Utils.getAttachId(res.responseData)
        });
        //知情同意书
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "1"
        }).then(res => {
          if (res.responseData.length > 0) this.files.consentList = this.Utils.getAttachId(res.responseData)
        });
        // 支付宝账号信息授权书
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "13"
        }).then(res => {
          if (res.responseData.length > 0) this.files.aliConsentList = this.Utils.getAttachId(res.responseData)
        })
        //贫困证明
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "2"
        }).then(res => {
          if (res.responseData.length > 0) this.files.poorEvidenceList = this.Utils.getAttachId(res.responseData)
        })
        //患儿生活照
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "4"
        }).then(res => {
          if (res.responseData.length > 0) this.files.lifePhotoList = this.Utils.getAttachId(res.responseData)
        })
        //患儿在院照片
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "5"
        }).then(res => {
          if (res.responseData.length > 0) this.files.inHospitalPhotoList = this.Utils.getAttachId(res.responseData)

        })
        //患儿家人全家福
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "6"
        }).then(res => {
          if (res.responseData.length > 0) this.files.familyPhotoList = this.Utils.getAttachId(res.responseData)
        })
        //家庭困难自述
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "7"
        }).then(res => {
          if (res.responseData.length > 0) this.files.poorNarrateList = this.Utils.getAttachId(res.responseData)
        })
        //患儿所在户口本/出生证明
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "11"
        }).then(res => {
          if (res.responseData.length > 0) this.files.registerPageList = this.Utils.getAttachId(res.responseData)
        })
        //其他资料
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "3"
        }).then(res => {
          if (res.responseData.length > 0) this.files.otherMaterialList = this.Utils.getAttachId(res.responseData)
        })

        //患儿大头照
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "9"
        }).then(res => {
          if (res.responseData.length > 0) this.files.facePhotoList = this.Utils.getAttachId(res.responseData)
        })

        //患儿出生证明
        getEvidenceAttachInfo({
          "helpId": this.helpData.helpId,
          "attachType": "12"
        }).then(res => {
          if (res.responseData.length > 0) this.files.idCardPhotoList = this.Utils.getAttachId(res.responseData)
        })
      },
      //获取其他收入列表
      getOtherIncome() {
        getOtherIncome({
          helpId: this.helpData.helpId
        }).then(res => {
          this.otherIncomeList = res.responseData
        })
      },
      //获取债务列表
      getDataByHelpId() {
        getDataByHelpId({
          helpId: this.helpData.helpId
        }).then(res => {
          this.debtData = res.responseData
          let arr = ['borrowAmount', 'repayAmount']				
          this.handleQueryAmount(arr,this.debtData)
        })
      },
      // 按救助编号查询证明人列表
      getcertifier() {
        getcertifierDataByHelpId({
          helpId: this.helpData.helpId
        }).then(res => {
          this.certifierlist = res.responseData
        })
      },
      //共同生活列表
      getFamilyMember() {
        let that = this
        that.familyMemberList = [];
        getFamilyMemberByHelpId({
          helpId: this.helpData.helpId
        }).then((res) => {
          let _list = res.responseData
          that.familyMemberList = _list;
          _list.forEach((item, index) => {
            getMemberAttachInfo({
              "subDataId": item.memberId,
              "attachType": "31"
            }).then(resAttach => {
              let param = that.Utils.getAttachId(resAttach.responseData);
              getFileListByIds(param).then(res1 => {
                that.$set(that.familyMemberList[index], 'hkAttach', res1.responseData)
              })
            })
          })
        })
        this.$forceUpdate()
      },
      handlePreview (imgUrl) {
        this.imageList = [imgUrl];
        this.showViewer = true;
      },
    }
  };
</script>

<style lang="scss" scoped>
  @import "src/common/common";
  @import "src/common/form";

  /deep/ .el-descriptions-row {
    th {
      width: 110px !important;
    }
  }
  .table-image__preview {
    margin-bottom: -8px;
    img {
      width: 24px;
      height: 24px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/child/view/ChildFamily.vue